"use strict";
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("@firebase/util");
var util_2 = require("@firebase/util");
var storage_1 = require("./storage/storage");
var Constants_1 = require("../realtime/Constants");
/**
 * A class that holds metadata about a Repo object
 *
 * @constructor
 */
var RepoInfo = /** @class */ (function () {
 /**
 * @param {string} host Hostname portion of the url for the repo
 * @param {boolean} secure Whether or not this repo is accessed over ssl
 * @param {string} namespace The namespace represented by the repo
 * @param {boolean} webSocketOnly Whether to prefer websockets over all other transports (used by Nest).
 * @param {string=} persistenceKey Override the default session persistence storage key
 */
 function RepoInfo(host, secure, namespace, webSocketOnly, persistenceKey) {
 if (persistenceKey === void 0) { persistenceKey = ''; }
 this.secure = secure;
 this.namespace = namespace;
 this.webSocketOnly = webSocketOnly;
 this.persistenceKey = persistenceKey;
 this.host = host.toLowerCase();
 this.domain = this.host.substr(this.host.indexOf('.') + 1);
 this.internalHost = storage_1.PersistentStorage.get('host:' + host) || this.host;
 }
 RepoInfo.prototype.needsQueryParam = function () {
 return this.host !== this.internalHost;
 };
 RepoInfo.prototype.isCacheableHost = function () {
 return this.internalHost.substr(0, 2) === 's-';
 };
 RepoInfo.prototype.isDemoHost = function () {
 return this.domain === 'firebaseio-demo.com';
 };
 RepoInfo.prototype.isCustomHost = function () {
 return (this.domain !== 'firebaseio.com' && this.domain !== 'firebaseio-demo.com');
 };
 RepoInfo.prototype.updateHost = function (newHost) {
 if (newHost !== this.internalHost) {
 this.internalHost = newHost;
 if (this.isCacheableHost()) {
 storage_1.PersistentStorage.set('host:' + this.host, this.internalHost);
 }
 }
 };
 /**
 * Returns the websocket URL for this repo
 * @param {string} type of connection
 * @param {Object} params list
 * @return {string} The URL for this repo
 */
 RepoInfo.prototype.connectionURL = function (type, params) {
 util_1.assert(typeof type === 'string', 'typeof type must == string');
 util_1.assert(typeof params === 'object', 'typeof params must == object');
 var connURL;
 if (type === Constants_1.WEBSOCKET) {
 connURL =
 (this.secure ? 'wss://' : 'ws://') + this.internalHost + '/.ws?';
 }
 else if (type === Constants_1.LONG_POLLING) {
 connURL =
 (this.secure ? 'https://' : 'http://') + this.internalHost + '/.lp?';
 }
 else {
 throw new Error('Unknown connection type: ' + type);
 }
 if (this.needsQueryParam()) {
 params['ns'] = this.namespace;
 }
 var pairs = [];
 util_2.forEach(params, function (key, value) {
 pairs.push(key + '=' + value);
 });
 return connURL + pairs.join('&');
 };
 /** @return {string} */
 RepoInfo.prototype.toString = function () {
 var str = this.toURLString();
 if (this.persistenceKey) {
 str += '<' + this.persistenceKey + '>';
 }
 return str;
 };
 /** @return {string} */
 RepoInfo.prototype.toURLString = function () {
 return (this.secure ? 'https://' : 'http://') + this.host;
 };
 return RepoInfo;
}());
exports.RepoInfo = RepoInfo;

//# sourceMappingURL=RepoInfo.js.map



//////////////////
// WEBPACK FOOTER
// ../database/dist/cjs/src/core/RepoInfo.js
// module id = 34
// module chunks = 0